import { PensieveGqlApiTagTypes } from 'app/apis/pensieve-gql-api';
import { api as fetchQueueApi } from './fetch-queue.generated';
import { api as fetchQueueAssignmentsApi } from './fetch-queue-assignments.generated';
import { api as fetchQueueEarningsApi } from './fetch-queue-earnings.generated';
import { api as fetchQueueHistoryApi } from './fetch-queue-history.generated';
import { api as joinQueueApi } from './join-queue.generated';
import { api as leaveQueueApi } from './leave-queue.generated';

fetchQueueApi.enhanceEndpoints({
  endpoints: {
    MentorDash_FetchQueue: {
      providesTags: [PensieveGqlApiTagTypes.Queue],
    },
  },
});

fetchQueueAssignmentsApi.enhanceEndpoints({
  endpoints: {
    MentorDash_FetchQueueAssignments: {
      providesTags: [PensieveGqlApiTagTypes.QueueAssignments],
    },
  },
});

fetchQueueHistoryApi.enhanceEndpoints({
  endpoints: {
    MentorDash_FetchHistory: {
      providesTags: [PensieveGqlApiTagTypes.QueueHistory],
    },
  },
});

fetchQueueEarningsApi.enhanceEndpoints({
  endpoints: {
    MentorDash_FetchEarningsSummary: {
      providesTags: [PensieveGqlApiTagTypes.QueueEarnings],
    },
  },
});

joinQueueApi.enhanceEndpoints({
  endpoints: {
    MentorDash_JoinQueue: {
      invalidatesTags: [PensieveGqlApiTagTypes.Queue, PensieveGqlApiTagTypes.QueueAssignments],
    },
  },
});

leaveQueueApi.enhanceEndpoints({
  endpoints: {
    MentorDash_LeaveQueue: {
      invalidatesTags: [PensieveGqlApiTagTypes.Queue, PensieveGqlApiTagTypes.QueueAssignments],
    },
  },
});

export const { useMentorDash_FetchQueueQuery: useFetchQueueQuery } = fetchQueueApi;
export const { useMentorDash_FetchQueueAssignmentsQuery: useFetchQueueAssignmentsQuery } = fetchQueueAssignmentsApi;
export const { useMentorDash_FetchHistoryQuery: useFetchQueueHistoryQuery } = fetchQueueHistoryApi;
export const { useMentorDash_FetchEarningsSummaryQuery: useFetchQueueEarningsSummaryQuery } = fetchQueueEarningsApi;
export const { useMentorDash_JoinQueueMutation: useJoinQueueMutation } = joinQueueApi;
export const { useMentorDash_LeaveQueueMutation: useLeaveQueueMutation } = leaveQueueApi;

export {
  fetchQueueApi,
  fetchQueueAssignmentsApi,
  fetchQueueEarningsApi,
  fetchQueueHistoryApi,
  joinQueueApi,
  leaveQueueApi,
};
